export interface IConfig {
  baseUrl: string;
  /** Device API key for the shop-phone face clock kiosk (maps to BiometricsAPIKey). */
  biometricsApiKey?: string;
}

export const ConfigConstants: IConfig = (window as any).ConfigConstants || {};
